import createAxios from '@/shared/axios';
import { API_BASE } from '@/shared/config';
import api from '@/shared/apiConfig';
/**
 * uniapi
 * @type {AxiosInstance}
 */
// desc 单独模块：获取场次监控会员记录
export const suixinhuanApiAxios = createAxios({
    baseURL: API_BASE.suixinhuan,
});
// desc 单独模块-从简版报告获取车辆图片
export const uniApiAxios = createAxios({
    baseURL: API_BASE.uniApi,
}, false, false);
uniApiAxios.interceptors.request.use((config) => {
    config['url'] = api[config.url] || config.url;
    return Object.assign({}, config);
}, (error) => Promise.reject(error));
// desc 竞拍模块
export const goodsAxios = createAxios({
    baseURL: API_BASE.goods,
});
// desc 订单模块
export const orderAxios = createAxios({
    baseURL: API_BASE.order,
});
// desc 用户模块
export const userAxios = createAxios({
    baseURL: API_BASE.user,
});
// desc 系统配置模块
export const systemAxios = createAxios({
    baseURL: API_BASE.systemConfig,
});
// desc 财务模块
export const financeAxios = createAxios({
    baseURL: API_BASE.finance,
});
// desc 竞拍核心模块
export const auctionAxios = createAxios({
    baseURL: API_BASE.auction,
});
// desc 基础数据模块
export const baseAxios = createAxios({
    baseURL: API_BASE.baseService,
});
// desc 数据报表模块
export const reportAxios = createAxios({
    baseURL: API_BASE.reportService,
});
/**
 * 直连
 * @type {AxiosInstance}
 */
// desc 竞拍模块
export const goodsAxiosDirect = createAxios({
    baseURL: API_BASE.goodsDirect,
});
// desc 订单模块
export const orderAxiosDirect = createAxios({
    baseURL: API_BASE.orderDirect,
});
// desc 用户模块
export const userAxiosDirect = createAxios({
    baseURL: API_BASE.userDirect,
});
// desc 系统配置模块
export const systemAxiosDirect = createAxios({
    baseURL: API_BASE.systemConfigDirect,
});
// desc 财务模块
export const financeAxiosDirect = createAxios({
    baseURL: API_BASE.financeDirect,
});
// desc 竞拍核心模块
export const auctionAxiosDirect = createAxios({
    baseURL: API_BASE.auctionDirect,
});
// desc 基础数据模块
export const baseAxiosDirect = createAxios({
    baseURL: API_BASE.baseServiceDirect,
});
// desc 数据报表模块
export const reportAxiosDirect = createAxios({
    baseURL: API_BASE.reportServiceDirect,
});
